export default {
    // --------Title--------
    rateInfo: '税率信息',
    detailsOfShippingRateCharges: '运费收费税率详情',
    detailsOfShippingRateInformation: '运费收费税率详细信息',
    ruleInfo: '规则信息',
    detailsOfShippingRule: '运输规则详细信息',
    ruleItemsInfo: '物品规则信息',
    detailsOfItemInformation: '物品详细信息',
    locationAndAreaSettings: '位置和区域设置',
    selectAreaForUpdateThePriceForEachRulesApplication: '选择该区域为每个规则应用更新价格, ',

    // --------Drawer-------
    changeDefaultMethodsFor: '更改默认设置用于',
    newAreaFor: '新区域用于',
    measureMethodRules: '测量方法规则',
    rules: '规则',
    Area: '区域',
    Weight: '重量',
    CBM: '立方',
    Unit: '单位',

    // --------MUI--------
    manageRules: '管理运输规则',
    manageShippingRates: '管理运费率',
    rateName: '税率名称',
    ruleName: '规则名称',
    calculationType: '计算类型',
    measureType: '测量类型',
    baseAmount: '基数',
    chargeMethod: '收费方式',
    minValue: '最小值',
    maxValue: '最大值',
    itemRate: '物品费率',
    addRule: '添加规则',

    empty: '暂无信息',
    defaultMeasureMethods: '默认测量方法',
    removeAreaRuleItem: '删除规则区域物品',
    addNewArea: '添加区域',
    changeDefault: '更改默认',
    areYouSureToDeleteThis: '你确定要删除吗',

};